module.exports = __webpack_public_path__ + "static/media/burger-how-it-works-1.e63d7ff4.jpg";